<template>
  <ul id="list-tasks">
    <li>
      <!--pc view-->
      <div v-if="!mobileView">
        <div id='registro'>
          <div id="headerList-comprobante" class="textHeaderList" style="width: 14%">{{moment(item.Fecha).format('DD/MM/YYYY')}}</div>
          <div id="headerList-tipo" class="textHeaderList" style="width: 14%">{{tipo(item.Tipo)}}</div>
          <div id="headerList-fecha" class="textHeaderList" style="width: 14%">{{item.Numero}}</div>
          <div id="headerList-vencimiento" class="textHeaderList" style="width: 14%">{{fechaVencimiento}}</div>
          <div id="headerList-monto" class="textHeaderList" style="width: 22%">$ {{item.Importe | formatMoney}}</div>
          <div id="headerList-saldo" class="textHeaderList" style="width: 22%">{{item.Acum | formatMoney}}</div>
        </div>
        <div  class="separator" style="width: 100%; height: 1px; background-color: #dddddd;">  </div>
      </div>
      <!--mobile view-->
      <div class="oblea" v-if="mobileView">
          <div class="fv lc" style="width: 100%; height: 100%;">
            <div class="fh cc" style="margin-left: 20px; font-size: 12px; font-weight: 500; color:#5D6770">
              <div style="width: 100px">Nro:</div>
              <div>{{item.Numero}}</div>
            </div>
            <div class="fh cc" style="margin-left: 20px;font-size: 12px; color:#5D6770; font-weight: 500">
              <div style="width: 100px">Tipo:</div>
              <div>{{tipo(item.Tipo)}}</div>
            </div>
            <div class="fh cc" style="margin-left: 20px;font-size: 12px; color:#5D6770; font-weight: 500">
              <div style="width: 100px">Fecha:</div>
              <div>{{moment(item.Fecha).format('DD/MM/YYYY')}}</div>
            </div>
            <div class="fh cc" style="margin-left: 20px; font-size: 12px; color:#5D6770; font-weight: 500">
              <div style="width: 100px">Vencimiento:</div>
              <div>{{fechaVencimiento}}</div>
            </div>
            <div class="fh cc" style="margin-left: 20px;font-size: 13px; font-weight: 800;margin-top: 10px; color:#5D6770">
              <div style="width: 100px">IMPORTE:</div>
              <div>$ {{item.Importe | formatMoney}}</div>
            </div>
            <div class="fh cc" style="margin-left: 20px; font-size: 13px; font-weight: 800;margin-top: 5px; color:#5D6770">
              <div style="width: 100px">SALDO ACUM:</div>
              <div>$ {{item.Acum | formatMoney}}</div>
            </div>
          </div>
        </div>
    </li>
  </ul>
</template>

<script>
import moment from 'moment'
import comprobante from '@components/views/ctacte/comprobante.vue'

export default {
  name: "item-cc",
  props: ["item"],

  data() {
       return {
         mobileView:false
       }
    },

  computed: {
      fechaVencimiento() {
        if ((this.item.FechaVencimiento != null) && (this.item.FechaVencimiento.length>0)) {
          return this.item.FechaVencimiento
        }
        else {
          return "   -"
        }
      }
  },


  methods: {

   onResize() {
        if (window.innerWidth > 600) {
           console.log('no')
          this.mobileView=false;
        }
        else {
           console.log('si')
          this.mobileView=true;
        }
    },


    tipo (key) {
      switch (key) {
        case 0:
          return 'SALDO INICIAL'
          break;
        case 1:
          return 'FACTURA'
          break;
        case 2:
          return 'NOTA DE CREDITO'
          break;
        case 3:
          return 'RECIBO'
          break;
        case 4:
          return 'PEDIDO MANUAL'
          break;
        case 5:
          return 'COBRANZA MANUAL'
          break;
        case 6:
          return 'AJUSTE'
          break;
        case 7:
          return 'PEDIDO'
          break;
        case 8:
          return 'COBRANZA'
          break;
        case 9:
          return 'AJUSTE IMPORTACION'
          break;
        case 10:
          return 'DEVOLUCIONES'
          break;
      }
    },

    moment,

    btnVerDetalle() {
      this.$store.commit('modal/with', { view: comprobante, value: this.item })
    },
  },

  mounted() {
   this.onResize()
  },

  created() {
    window.addEventListener('resize', this.onResize)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  }

};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}


 .oblea {
    width: 90vw;
    height:120px;
    margin-bottom: 10px;
    background: #ffffff;  
    border-style: solid;
    border-width: 1px;
    border-radius: 15px;
    border: 1px solid #dddddd;
    box-shadow: 1px 1px 2px #dddddd;
    display: flex;
    flex-direction: row;
    align-items: flex-start; 
    justify-content: flex-start;
  }


#registro {
  width: 650px;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: #ffffff;
}

.textHeaderList {
  color: #656e76;
  font-size: 10px;
  font-weight: 500;
}

.saldoPos {
  color: #04b590;
  font-size: 10px;
  font-weight: 500;
}

.saldoNeg {
  color: #e34860;
  font-size: 10px;
  font-weight: 500;
}

.saldoNeutro {
  color: #4969b2;
  font-size: 10px;
  font-weight: 500;
}

.checkContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

#iconVer {
  width: 15px;
  height: 15px;
}

#iconVer:hover {
  cursor: pointer;
}
</style>




// WEBPACK FOOTER //
// src/components/views/ctacte/item.vue